import { useUserSettings } from "@/hooks/useUserSettings";
import {
  DatabaseOutlined,
  LogoutOutlined,
  SettingOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";

import Skeleton from "@/components/Skeleton/Skeleton";
import { Avatar, Dropdown } from "antd";
import { Link } from "react-router-dom";
import styles from "./ProfileMenu.module.scss";
import useLogout from "./useLogout";

const ProfileMenu = () => {
  const { data: userData } = useUserSettings();
  const { logout } = useLogout();

  const items = [
    {
      icon: <UserOutlined />,
      label: <Link to="/account">Account</Link>,
      key: "Account",
    },
    {
      icon: <TeamOutlined />,
      label: <Link to="/team">Team</Link>,
      key: "Team",
    },
    {
      icon: <SettingOutlined />,
      label: <Link to="/settings">Settings</Link>,
      key: "Settings",
    },
    {
      icon: <DatabaseOutlined />,
      label: <Link to="/snapshots">Snapshots</Link>,
      key: "Snapshots",
    },
    {
      onClick: () => logout(),
      label: "Logout",
      key: "Logout",
      icon: <LogoutOutlined />,
    },
  ];

  return (
    <div className={styles.ProfileMenu}>
      <Dropdown
        menu={{
          items,
        }}
        className={styles.dropdown}
      >
        <div className={styles.profile}>
          <span className={styles.name}>
            {userData?.user_name ? (
              <span className="name">{userData.user_name}</span>
            ) : (
              <Skeleton style={{ width: "100%", height: 20 }} />
            )}
          </span>
          <Avatar
            size={30}
            icon={<UserOutlined />}
            className={styles.avatar}
          />
        </div>
      </Dropdown>
    </div>
  );
};

export default ProfileMenu;
